import axios from "axios";
import { toast } from "sonner";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const api = axios.create({ baseURL: API, withCredentials: true });

export function formatApiError(detail) {
  if (detail == null) return "Terjadi kesalahan. Silakan coba lagi.";
  if (typeof detail === "string") return detail;
  if (detail && typeof detail === "object" && typeof detail.message === "string") return detail.message;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

// Penanganan error umum untuk alat analisis (paywall & verifikasi email)
export function handleToolError(err, navigate) {  const st = err.response?.status;
  const detail = err.response?.data?.detail;
  const code = detail?.code;
  if (st === 402) {
    window.dispatchEvent(new CustomEvent("trial-exhausted"));
    return;
  }
  if (st === 403 && code === "EMAIL_NOT_VERIFIED") {
    toast.error(detail.message || "Verifikasi email Anda untuk melanjutkan.", {
      action: {
        label: "Kirim ulang",
        onClick: async () => {
          try { await api.post("/auth/resend-verification"); toast.success("Tautan verifikasi dikirim."); } catch { /* noop */ }
        },
      },
    });
    return;
  }
  toast.error(formatApiError(detail));
}

// Tampilkan penawaran Paket Coba 3 Hari setelah hasil analisis terakhir (trial habis) berhasil tampil
export function maybeShow3DayOffer(credit) {
  if (credit?.show_3_day_offer) window.dispatchEvent(new CustomEvent("show-3-day-offer"));
}

export { API };
export default api;
